import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { FormattedValueHint } from '@/components/EditableSectionField/FormattedValueHint/FormattedValueHint';
import {
	getCallingCodeForIso,
	getExampleNationalNumberForIso,
	getExtensionPrefixForIso
} from '@/utils/formatters/phoneCountryCode';

type Props = {
	visible: boolean;
	anchorEl: HTMLElement | null;
	countryIso?: string;
	error?: string | null;
	customSx?: SxProps<Theme>;
	boundaryEl?: HTMLElement | null;
	subtractWidth?: number;
};

export const PhoneNumberHint = ({
	visible,
	anchorEl,
	countryIso,
	error,
	customSx,
	boundaryEl,
	subtractWidth
}: Props) => {
	const { t } = useTranslation();

	const extensionPrefix = getExtensionPrefixForIso(countryIso);
	const callingCode = getCallingCodeForIso(countryIso) || '1';
	const exampleNationalNumber = getExampleNationalNumberForIso(countryIso);

	const message =
		error ??
		t(
			'Include extension as {{pattern}}, e.g. +{{callingCode}} {{exampleNationalNumber}} {{example}}',
			{
				pattern: `${extensionPrefix}<digits>`,
				callingCode,
				exampleNationalNumber,
				example: `${extensionPrefix}42`
			}
		);

	return (
		<FormattedValueHint
			message={message}
			isError={!!error}
			open={visible}
			anchorEl={anchorEl}
			customSx={customSx}
			boundaryEl={boundaryEl}
			subtractWidth={subtractWidth}
		/>
	);
};
